var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBlock = function SvgBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#block_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF2C58",
    d: "M12.5 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm-8 10c0-1.85.63-3.55 1.69-4.9L17.4 18.31A7.963 7.963 0 0 1 12.5 20c-4.42 0-8-3.58-8-8Zm14.31 4.9L7.6 5.69A7.963 7.963 0 0 1 12.5 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "block_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 2h20v20h-20z"
  })))));
};
export default SvgBlock;